import { Injectable } from "@angular/core";

export class CountryCodes {
  data_code: string
  data_country: string;
}

export const Country_DE: CountryCodes[] = [
  { data_code: '+49', data_country: 'Deutschland (+49)' },
  { data_code: '+43', data_country: 'Österreich (+43)' },
  { data_code: '+41', data_country: 'Schweiz (+41)' },
  { data_code: '+20', data_country: 'Ägypten (+20)' },
  { data_code: '+355', data_country: 'Albanien  (+355)' },
  { data_code: '+213', data_country: 'Algerien (+213)' },
  { data_code: '+376', data_country: 'Andorra(+376)' },
  { data_code: '+244', data_country: 'Angola(+244)' },
  { data_code: '+1', data_country: 'Anguilla(+1)' },
  { data_code: '+1', data_country: 'Antigua und Barbuda(+1)' },
  { data_code: '+54', data_country: 'Argentinien(+54)' },
  { data_code: '+374', data_country: 'Armenien(+374)' },
  { data_code: '+297', data_country: 'Aruba(+297) ' },
  { data_code: '+994', data_country: 'Aserbaidschan(+994)' },
  { data_code: '+251', data_country: 'Äthiopien (+251 ' },
  { data_code: '+61', data_country: 'Australien (+61)' },
  { data_code: '+1', data_country: 'Bahamas (+1)' },
  { data_code: '+973', data_country: 'Bahrain (+973)' },
  { data_code: '+1', data_country: 'Barbados (+1)' },
  { data_code: '+375', data_country: 'Belarus (+375)' },
  { data_code: '+32', data_country: 'Belgien (+32)' },
  { data_code: '+501', data_country: 'Belize (+501)' },
  { data_code: '+229', data_country: 'Benin (+229)' },
  { data_code: '+1', data_country: 'Bermuda(+1)' },
  { data_code: '+975', data_country: 'Bhutan (+975)' },
  { data_code: '+591', data_country: 'Bolivien (+591)' },
  { data_code: '+387', data_country: 'Bosnien und Herzegowina (+387)' },
  { data_code: '+267', data_country: 'Botsuana (+267)' },
  { data_code: '+55', data_country: 'Brasilien (+55)' },
  { data_code: '+1', data_country: 'Britische Jungferninseln (+1) ' },
  { data_code: '+673', data_country: 'Brunei Darussalam (+673)' },
  { data_code: '+359', data_country: 'Bulgarien (+359)' },
  { data_code: '+226', data_country: 'Burkina Faso (+226)' },
  { data_code: '+257', data_country: 'Burundi (+257)' },
  { data_code: '+56', data_country: 'Chile(+56)' },
  { data_code: '+86', data_country: 'China (+86)' },
  { data_code: '+682', data_country: 'Cookinseln (+682)' },
  { data_code: '+506', data_country: 'Costa Rica (+506)' },
  { data_code: "+225", data_country: 'Côte d’Ivoire (+225)' },
  { data_code: "+45", data_country: 'Dänemark (+45)' },
  { data_code: "+1", data_country: ' Dominica (+1)' },
  { data_code: "+1", data_country: 'Dominikanische Republik (+1)' },
  { data_code: "+253", data_country: 'Dschibuti (+253)' },
  { data_code: "+593", data_country: 'Ecuador (+593)' },
  { data_code: "+503", data_country: 'El Salvador (+503)' },
  { data_code: "+291", data_country: 'Eritrea (+291)' },
  { data_code: "+372", data_country: 'Estland (+372)' },
  { data_code: "+500", data_country: 'Falklandinseln (+500)' },
  { data_code: "+298", data_country: 'Färöer (+298)' },
  { data_code: "+679", data_country: 'Fidschi (+679)' },
  { data_code: "+358", data_country: 'Finnland (+358)' },
  { data_code: "+33", data_country: 'Frankreich (+33)' },
  { data_code: "+594", data_country: 'Französisch-Guayana (+594)' },
  { data_code: "+689", data_country: 'Französisch-Polynesien (+689)' },
  { data_code: "+241", data_country: 'Gabun (+241)' },
  { data_code: "+220", data_country: 'Gambia (+220)' },
  { data_code: "+995", data_country: 'Georgien (+995)' },
  { data_code: "+350", data_country: 'Gibraltar (+350)' },
  { data_code: "+1", data_country: 'Grenada (+1)' },
  { data_code: "+30", data_country: 'Griechenland (+30)' },
  { data_code: "+299", data_country: 'Grönland (+299)' },
  { data_code: '+590', data_country: 'Guadeloupe (+590)' },
  { data_code: '+502', data_country: 'Guatemala (+502)' },
  { data_code: '+224', data_country: 'Guinea (+224)' },
  { data_code: '+245', data_country: 'Guinea-Bissau (+245)' },
  { data_code: '+592', data_country: 'Guyana (+592)' },
  { data_code: '+504', data_country: 'Honduras (+504)' },
  { data_code: '+91', data_country: 'Indien (+91)' },
  { data_code: '+62', data_country: 'Indonesien (+62)' },
  { data_code: '+353', data_country: 'Irland (+353)' },
  { data_code: '+354', data_country: 'Island (+354)' },
  { data_code: '+972', data_country: 'Israel (+972)' },
  { data_code: '+39', data_country: 'Italien (+39)' },
  { data_code: '+1', data_country: 'Jamaika (+1)' },
  { data_code: '+81', data_country: 'Japan (+81)' },
  { data_code: '+967', data_country: 'Jemen (+967)' },
  { data_code: '+962', data_country: 'Jordanien (+962)' },
  { data_code: '+1', data_country: 'Kaimaninseln (+1)' },
  { data_code: '+855', data_country: 'Kambodscha (+855)' },
  { data_code: '+237', data_country: 'Kamerun (+237)' },
  { data_code: '+1', data_country: 'Kanada (+1)' },
  { data_code: '+238', data_country: 'Kap Verde (+238)' },
  { data_code: '+7', data_country: 'Kasachstan (+7)' },
  { data_code: '+974', data_country: 'Katar (+974)' },
  { data_code: '+254', data_country: 'Kenia (+254)' },
  { data_code: '+996', data_country: 'Kirgisistan (+996)' },
  { data_code: '+686', data_country: 'Kiribati (+686)' },
  { data_code: '+57', data_country: 'Kolumbien (+57)' },
  { data_code: '+269', data_country: 'Komoren (+269)' },
  { data_code: '+242', data_country: 'Kongo-Brazzaville (+242)' },
  { data_code: '+243', data_country: 'Kongo-Kinshasa (+243)' },
  { data_code: "+383", data_country: 'Kosovo (+383)' },
  { data_code: '+385', data_country: 'Kroatien (+385)' },
  { data_code: '+965', data_country: 'Kuwait (+965)' },
  { data_code: '+856', data_country: 'Laos (+856)' },
  { data_code: '+266', data_country: 'Lesotho (+266)' },
  { data_code: '+371', data_country: 'Lettland (+371)' },
  { data_code: '+423', data_country: 'Liechtenstein (+423)' },
  { data_code: '+370', data_country: 'Litauen (+370)' },
  { data_code: '+352', data_country: 'Luxemburg (+352)' },
  { data_code: '+261', data_country: 'Madagaskar (+261)' },
  { data_code: '+265', data_country: 'Malawi (+265)' },
  { data_code: '+60', data_country: 'Malaysia (+60)' },
  { data_code: '+960', data_country: 'Malediven (+960)' },
  { data_code: '+223', data_country: 'Mali (+223)' },
  { data_code: '+356', data_country: 'Malta (+356)' },
  { data_code: '+212', data_country: 'Marokko (+212)' },
  { data_code: '+692', data_country: 'Marshallinseln (+692)' },
  { data_code: '+596', data_country: 'Martinique (+596)' },
  { data_code: '+222', data_country: 'Mauretanien (+222)' },
  { data_code: '+230', data_country: 'Mauritius (+230)' },
  { data_code: '+262', data_country: 'Mayotte (+262)' },
  { data_code: '+389', data_country: 'Mazedonien (+389)' },
  { data_code: '+52', data_country: 'Mexiko (+52)' },
  { data_code: '+691', data_country: 'Mikronesien (+691)' },
  { data_code: '+377', data_country: 'Monaco (+377)' },
  { data_code: '+976', data_country: 'Mongolei (+976)' },
  { data_code: '+382', data_country: 'Montenegro (+382)' },
  { data_code: '+1', data_country: 'Montserrat (+1)' },
  { data_code: '+258', data_country: 'Mosambik (+258)' },
  { data_code: '+264', data_country: 'Namibia (+264)' },
  { data_code: '+674', data_country: 'Nauru (+674)' },
  { data_code: '+977', data_country: 'Nepal (+977)' },
  { data_code: '+687', data_country: 'Neukaledonien (+687)' },
  { data_code: '+64', data_country: 'Neuseeland (+64)' },
  { data_code: '+505', data_country: 'Nicaragua (+505)' },
  { data_code: '+31', data_country: 'Niederlande (+31)' },
  { data_code: '+599', data_country: 'Niederländische Antillen (+599)' },
  { data_code: '+227', data_country: 'Niger (+227)' },
  { data_code: '+234', data_country: 'Nigeria (+234)' },
  { data_code: '+683', data_country: 'Niue (+683)' },
  { data_code: '+672', data_country: 'Norfolkinsel (+672)' },
  { data_code: '+47', data_country: 'Norwegen (+47)' },
  { data_code: '+968', data_country: 'Oman (+968)' },
  { data_code: '+680', data_country: 'Palau (+680)' },
  { data_code: '+507', data_country: 'Panama (+507)' },
  { data_code: '+675', data_country: 'Papua-Neuguinea (+675)' },
  { data_code: '+595', data_country: 'Paraguay (+595)' },
  { data_code: '+51', data_country: 'Peru (+51)' },
  { data_code: '+63', data_country: 'Philippinen (+63)' },
  { data_code: '+64', data_country: 'Pitcairninseln (+64)' },
  { data_code: '+48', data_country: 'Polen (+48)' },
  { data_code: '+351', data_country: 'Portugal (+351)' },
  { data_code: '+373', data_country: 'Republik Moldau (+373)' },
  { data_code: '+262', data_country: 'Réunion (+262)' },
  { data_code: '+250', data_country: 'Ruanda (+250)' },
  { data_code: '+40', data_country: 'Rumänien (+40)' },
  { data_code: '+7', data_country: 'Russland (+7)' },
  { data_code: '+677', data_country: 'Salomonen (+677)' },
  { data_code: '+260', data_country: 'Sambia (+260)' },
  { data_code: '+685', data_country: 'Samoa (+685)' },
  { data_code: '+378', data_country: 'San Marino (+378)' },
  { data_code: '+239', data_country: 'São Tomé und Príncipe (+239)' },
  { data_code: '+966', data_country: 'Saudi-Arabien (+966)' },
  { data_code: '+46', data_country: 'Schweden (+46)' },
  { data_code: '+221', data_country: 'Senegal (+221)' },
  { data_code: '+381', data_country: 'Serbien (+381)' },
  { data_code: '+248', data_country: 'Seychellen (+248)' },
  { data_code: '+232', data_country: 'Sierra Leone (+232)' },
  { data_code: '+263', data_country: 'Simbabwe (+263)' },
  { data_code: '+65', data_country: 'Singapur (+65)' },
  { data_code: '+421', data_country: 'Slowakei (+421)' },
  { data_code: '+386', data_country: 'Slowenien (+386)' },
  { data_code: '+252', data_country: 'Somalia (+252)' },
  { data_code: '+852', data_country: 'Sonderverwaltungszone Hongkong (+852)' },
  { data_code: '+34', data_country: 'Spanien (+34)' },
  { data_code: '+94', data_country: 'Sri Lanka (+94)' },
  { data_code: '+290', data_country: 'St. Helena (+290)' },
  { data_code: '+1', data_country: 'St. Kitts und Nevis (+1)' },
  { data_code: '+1', data_country: 'St. Lucia (+1)' },
  { data_code: '+508', data_country: 'St. Pierre und Miquelon (+508)' },
  { data_code: '+1', data_country: 'St. Vincent und die Grenadinen (+1)' },
  { data_code: '+27', data_country: 'Südafrika (+27)' },
  { data_code: '+82', data_country: 'Südkorea (+82)' },
  { data_code: '+597', data_country: 'Suriname (+597)' },
  { data_code: '+47', data_country: 'Svalbard und Jan Mayen (+47)' },
  { data_code: '+268', data_country: 'Swasiland (+268)' },
  { data_code: '+992', data_country: 'Tadschikistan (+992)' },
  { data_code: '+886', data_country: 'Taiwan (+886)' },
  { data_code: '+255', data_country: 'Tansania (+255)' },
  { data_code: '+66', data_country: 'Thailand (+66)' },
  { data_code: '+228', data_country: 'Togo (+228)' },
  { data_code: '+676', data_country: 'Tonga (+676)' },
  { data_code: '+1', data_country: 'Trinidad und Tobago (+1)' },
  { data_code: '+235', data_country: 'Tschad (+235)' },
  { data_code: '+420', data_country: 'Tschechische Republik (+420)' },
  { data_code: '+216', data_country: 'Tunesien (+216)' },
  { data_code: '+90', data_country: 'Türkei (+90)' },
  { data_code: '+993', data_country: 'Turkmenistan (+993)' },
  { data_code: '+1', data_country: 'Turks- und Caicosinseln (+1)' },
  { data_code: '+688', data_country: 'Tuvalu (+688)' },
  { data_code: '+256', data_country: 'Uganda (+256)' },
  { data_code: '+380', data_country: 'Ukraine (+380)' },
  { data_code: '+36', data_country: 'Ungarn (+36)' },
  { data_code: '+598', data_country: 'Uruguay (+598)' },
  { data_code: '+678', data_country: 'Vanuatu (+678)' },
  { data_code: '+39', data_country: 'Vatikanstadt (+39)' },
  { data_code: '+58', data_country: 'Venezuela (+58)' },
  { data_code: '+971', data_country: 'Vereinigte Arabische Emirate (+971)' },
  { data_code: '+1', data_country: 'Vereinigte Staaten (+1)' },
  { data_code: '+44', data_country: 'Vereinigtes Königreich (+44)' },
  { data_code: '+84', data_country: 'Vietnam (+84)' },
  { data_code: '+681', data_country: 'Wallis und Futuna (+681)' },
  { data_code: '+357', data_country: 'Zypern (+357)' },

];

export const Country_EN: CountryCodes[] = [
  { data_code: '+49', data_country: 'Germany (+49)' },
  { data_code: "+43", data_country: 'Austria (+43)' },
  { data_code: '+41', data_country: 'Switzerland (+41)' },
  { data_code: "+355", data_country: 'Albania (+355)' },
  { data_code: "+213", data_country: 'Algeria (+213)' },
  { data_code: "+376", data_country: 'Andorra (+376)' },
  { data_code: "+244", data_country: 'Angola (+244)' },
  { data_code: "+1", data_country: 'Anguilla (+1)' },
  { data_code: "+1", data_country: 'Antigua &amp; Barbuda (+1)' },
  { data_code: "+54", data_country: 'Argentina (+54)' },
  { data_code: "+374", data_country: 'Armenia (+374)' },
  { data_code: "+297", data_country: 'Aruba (+297)' },
  { data_code: "+61", data_country: 'Australia (+61)' },
  { data_code: "+994", data_country: 'Azerbaijan (+994)' },
  { data_code: "+1", data_country: 'Bahamas (+1)' },
  { data_code: "+973", data_country: 'Bahrain (+973)' },
  { data_code: "+1", data_country: 'Barbados (+1)' },
  { data_code: "+375", data_country: 'Belarus (+375)' },
  { data_code: "+32", data_country: 'Belgium (+32)' },
  { data_code: "+501", data_country: 'Belize (+501)' },
  { data_code: "+229", data_country: 'Benin (+229)' },
  { data_code: "+1", data_country: 'Bermuda (+1)' },
  { data_code: "+975", data_country: 'Bhutan (+975)' },
  { data_code: "+591", data_country: 'Bolivia (+591)' },
  { data_code: "+387", data_country: 'Bosnia &amp; Herzegovina (+387)' },
  { data_code: "+267", data_country: 'Botswana (+267)' },
  { data_code: "+55", data_country: 'Brazil (+55)' },
  { data_code: "+1", data_country: 'British Virgin Islands (+1)' },
  { data_code: "+673", data_country: 'Brunei (+673)' },
  { data_code: '+359', data_country: 'Bulgaria (+359)' },
  { data_code: '+226', data_country: 'Burkina Faso (+226)' },
  { data_code: '+257', data_country: 'Burundi (+257)' },
  { data_code: '+855', data_country: 'Cambodia (+855)' },
  { data_code: '+237', data_country: 'Cameroon (+237)' },
  { data_code: '+1', data_country: 'Canada (+1)' },
  { data_code: '+238', data_country: 'Cape Verde (+238)' },
  { data_code: '+1', data_country: 'Cayman Islands (+1)' },
  { data_code: '+235', data_country: 'Chad (+235)' },
  { data_code: '+56', data_country: 'Chile (+56)' },
  { data_code: '+86', data_country: 'China (+86)' },
  { data_code: '+57', data_country: 'Colombia (+57)' },
  { data_code: '+269', data_country: 'Comoros (+269)' },
  { data_code: '+242', data_country: 'Congo - Brazzaville (+242)' },
  { data_code: '+243', data_country: 'Congo - Kinshasa (+243)' },
  { data_code: '+682', data_country: 'Cook Islands (+682)' },
  { data_code: '+506', data_country: 'Costa Rica (+506)' },
  { data_code: '+225', data_country: 'Côte d’Ivoire (+225)' },
  { data_code: '+385', data_country: 'Croatia (+385)' },
  { data_code: '+357', data_country: 'Cyprus (+357)' },
  { data_code: '+420', data_country: 'Czech Republic (+420)' },
  { data_code: '+45', data_country: 'Denmark (+45)' },
  { data_code: '+253', data_country: 'Djibouti (+253)' },
  { data_code: '+1', data_country: 'Dominica (+1)' },
  { data_code: '+1', data_country: 'Dominican Republic (+1)' },
  { data_code: '+593', data_country: 'Ecuador (+593)' },
  { data_code: '+20', data_country: 'Egypt (+20)' },
  { data_code: '+503', data_country: 'El Salvador (+503)' },
  { data_code: '+291', data_country: 'Eritrea (+291)' },
  { data_code: '+372', data_country: 'Estonia (+372)' },
  { data_code: '+251', data_country: 'Ethiopia (+251)' },
  { data_code: '+500', data_country: 'Falkland Islands (+500)' },
  { data_code: '+298', data_country: 'Faroe Islands (+298)' },
  { data_code: '+679', data_country: 'Fiji (+679)' },
  { data_code: '+358', data_country: 'Finland (+358)' },
  { data_code: '+33', data_country: 'France (+33)' },
  { data_code: '+594', data_country: 'rench Guiana (+594)' },
  { data_code: '+689', data_country: 'French Polynesia (+689)' },
  { data_code: '+241', data_country: 'Gabon (+241)' },
  { data_code: '+220', data_country: 'Gambia (+220)' },
  { data_code: '+995', data_country: 'Georgia (+995)' },
  { data_code: '+350', data_country: 'Gibraltar (+350)' },
  { data_code: '+30', data_country: 'Greece (+30)' },
  { data_code: '+299', data_country: 'Greenland (+299)' },
  { data_code: '+1', data_country: 'Grenada (+1)' },
  { data_code: '+590', data_country: 'Guadeloupe (+590)' },
  { data_code: '+502', data_country: 'Guatemala (+502)' },
  { data_code: "+224", data_country: 'Guinea (+224)' },
  { data_code: "+245", data_country: 'Guinea-Bissau (+245)' },
  { data_code: "+592", data_country: 'Guyana (+592)' },
  { data_code: "+504", data_country: 'Honduras (+504)' },
  { data_code: "+852", data_country: 'Hong Kong SAR China (+852)' },
  { data_code: "+36", data_country: 'Hungary (+36)' },
  { data_code: "+354", data_country: 'Iceland (+354)' },
  { data_code: "+91", data_country: 'India (+91)' },
  { data_code: "+62", data_country: 'Indonesia (+62)' },
  { data_code: "+353", data_country: 'Ireland (+353)' },
  { data_code: "+972", data_country: 'Israel (+972)' },
  { data_code: "+39", data_country: 'Italy (+39)' },
  { data_code: "+1", data_country: 'Jamaica (+1)' },
  { data_code: "+81", data_country: 'Japan (+81)' },
  { data_code: "+962", data_country: 'Jordan (+962)' },
  { data_code: "+7", data_country: 'Kazakhstan (+7)' },
  { data_code: "+254", data_country: 'Kenya (+254)' },
  { data_code: "+686", data_country: 'Kiribati (+686)' },
  { data_code: "+383", data_country: 'Kosovo (+383)' },
  { data_code: "+965", data_country: 'Kuwait (+965)' },
  { data_code: "+996", data_country: 'Kyrgyzstan (+996)' },
  { data_code: "+856", data_country: 'Laos (+856)' },
  { data_code: "+371", data_country: 'Latvia (+371)' },
  { data_code: "+266", data_country: 'Lesotho (+266)' },
  { data_code: "+423", data_country: 'Liechtenstein (+423)' },
  { data_code: "+370", data_country: 'Lithuania (+370)' },
  { data_code: "+352", data_country: 'Luxembourg (+352)' },
  { data_code: "+389", data_country: 'Macedonia (+389)' },
  { data_code: "+261", data_country: 'Madagascar (+261)' },
  { data_code: "+265", data_country: 'Malawi (+265)' },
  { data_code: "+60", data_country: 'Malaysia (+60)' },
  { data_code: "+960", data_country: 'Maldives (+960)' },
  { data_code: "+223", data_country: 'Mali (+223)' },
  { data_code: "+356", data_country: 'Malta (+356)' },
  { data_code: "+692", data_country: 'Marshall Islands (+692)' },
  { data_code: "+596", data_country: 'Martinique (+596)' },
  { data_code: "+222", data_country: 'Mauritania (+222)' },
  { data_code: "+230", data_country: 'Mauritius (+230)' },
  { data_code: "+262", data_country: 'Mayotte (+262)' },
  { data_code: "+52", data_country: 'Mexico (+52)' },
  { data_code: "+691", data_country: 'Micronesia (+691)' },
  { data_code: "+373", data_country: 'Moldova (+373)' },
  { data_code: "+377", data_country: 'Monaco (+377)' },
  { data_code: "+976", data_country: 'Mongolia (+976)' },
  { data_code: "+382", data_country: 'Montenegro (+382)' },
  { data_code: "+1", data_country: 'Montserrat (+1)' },
  { data_code: "+212", data_country: 'Morocco (+212)' },
  { data_code: "+258", data_country: 'Mozambique (+258)' },
  { data_code: "+264", data_country: 'Namibia (+264)' },
  { data_code: '+674', data_country: 'Nauru (+674)' },
  { data_code: '+977', data_country: 'Nepal (+977)' },
  { data_code: '+31', data_country: 'Netherlands (+31)' },
  { data_code: '+599', data_country: 'Netherlands Antilles (+599)' },
  { data_code: '+687', data_country: 'New Caledonia (+687)' },
  { data_code: '+64', data_country: 'New Zealand (+64)' },
  { data_code: '+505', data_country: 'Nicaragua (+505)' },
  { data_code: '+227', data_country: 'Niger (+227)' },
  { data_code: '+234', data_country: 'Nigeria (+234)' },
  { data_code: '+683', data_country: 'Niue (+683)' },
  { data_code: '+672', data_country: 'Norfolk Island (+672)' },
  { data_code: '+47', data_country: 'Norway (+47)' },
  { data_code: '+968', data_country: 'Oman (+968)' },
  { data_code: '+680', data_country: 'Palau (+680)' },
  { data_code: '+507', data_country: 'Panama (+507)' },
  { data_code: '+675', data_country: 'Papua New Guinea (+675)' },
  { data_code: '+595', data_country: 'Paraguay (+595)' },
  { data_code: '+51', data_country: 'Peru (+51)' },
  { data_code: '+63', data_country: 'Philippines (+63)' },
  { data_code: '+64', data_country: 'Pitcairn Islands (+64)' },
  { data_code: '+48', data_country: 'Poland (+48)' },
  { data_code: '+351', data_country: 'Portugal (+351)' },
  { data_code: '+974', data_country: 'Qatar (+974)' },
  { data_code: '+262', data_country: 'Réunion (+262)' },
  { data_code: '+40', data_country: 'Romania (+40)' },
  { data_code: '+7', data_country: 'Russia (+7)' },
  { data_code: '+250', data_country: 'Rwanda (+250)' },
  { data_code: '+685', data_country: 'Samoa (+685)' },
  { data_code: '+378', data_country: 'San Marino (+378)' },
  { data_code: '+239', data_country: 'São Tomé &amp; Príncipe (+239)' },
  { data_code: '+966', data_country: 'Saudi Arabia (+966)' },
  { data_code: '+221', data_country: 'Senegal (+221)' },
  { data_code: '+381', data_country: 'Serbia (+381)' },
  { data_code: '+248', data_country: 'Seychelles (+248)' },
  { data_code: '+232', data_country: 'Sierra Leone (+232)' },
  { data_code: '+65', data_country: 'Singapore (+65)' },
  { data_code: '+421', data_country: 'Slovakia (+421)' },
  { data_code: '+386', data_country: 'Slovenia (+386)' },
  { data_code: '+677', data_country: 'Solomon Islands (+677)' },
  { data_code: '+252', data_country: 'Somalia (+252)' },
  { data_code: '+27', data_country: 'South Africa (+27)' },
  { data_code: '+82', data_country: 'South Korea (+82)' },
  { data_code: '+34', data_country: 'Spain (+34)' },
  { data_code: '+94', data_country: 'Sri Lanka (+94)' },
  { data_code: '+290', data_country: 'St. Helena (+290)' },
  { data_code: '+1', data_country: 'St. Kitts &amp; Nevis (+1)' },
  { data_code: '+1', data_country: 'St. Lucia (+1)' },
  { data_code: '+508', data_country: 'St. Pierre &amp; Miquelon (+508)' },
  { data_code: '+1', data_country: 'St. Vincent &amp; Grenadines (+1)' },
  { data_code: '+597', data_country: 'Suriname (+597)' },
  { data_code: '+47', data_country: 'Svalbard &amp; Jan Mayen (+47)' },
  { data_code: '+268', data_country: 'Swaziland (+268)' },
  { data_code: '+46', data_country: 'Sweden (+46)' },
  { data_code: '+886', data_country: 'Taiwan (+886)' },
  { data_code: '+992', data_country: 'Tajikistan (+992)' },
  { data_code: '+255', data_country: 'Tanzania (+255)' },
  { data_code: '+66', data_country: 'Thailand (+66)' },
  { data_code: '+228', data_country: 'Togo (+228)' },
  { data_code: '+676', data_country: 'Tonga (+676)' },
  { data_code: '+1', data_country: 'Trinidad &amp; Tobago (+1)' },
  { data_code: '+216', data_country: 'Tunisia (+216)' },
  { data_code: '+90', data_country: 'Turkey (+90)' },
  { data_code: '+993', data_country: 'Turkmenistan (+993)' },
  { data_code: '+1', data_country: 'Turks &amp; Caicos Islands (+1)' },
  { data_code: '+688', data_country: 'Tuvalu (+688)' },
  { data_code: '+256', data_country: 'Uganda (+256)' },
  { data_code: '+380', data_country: 'Ukraine (+380)' },
  { data_code: '+971', data_country: 'United Arab Emirates (+971)' },
  { data_code: '+44', data_country: 'United Kingdom (+44)' },
  { data_code: '+1', data_country: 'United States (+1)' },
  { data_code: '+598', data_country: 'Uruguay (+598)' },
  { data_code: '+678', data_country: 'Vanuatu (+678)' },
  { data_code: '+39', data_country: 'Vatican City (+39)' },
  { data_code: '+58', data_country: 'Venezuela (+58)' },
  { data_code: '+84', data_country: 'Vietnam (+84)' },
  { data_code: '+681', data_country: 'Wallis &amp; Futuna (+681)' },
  { data_code: '+967', data_country: 'Yemen (+967)' },
  { data_code: '+260', data_country: 'Zambia (+260)' },
  { data_code: '+263', data_country: 'Zimbabwe (+263)' },
]

@Injectable()
export class PhoneNumberInputService {
  constructor() { }
}
